import type { ConfigurationFormBuilderWrapperProps } from '../configuration-form-builder-wrapper/ConfigurationFormBuilderWrapper.ctrl';
import type { ForwardedRef, ReactElement } from 'react';
import { useRef } from 'react';
import { useExposedConfigurationFormBuilderWrapperProviderValueV2 } from '../exposed-configuration-form-builder-wrapper/hooks/useExposedConfigurationFormBuilderWrapperProviderValueV2.hook';
import { useExposedReactFormGeneratorProviderValue } from '../exposed-configuration-form-builder-wrapper/hooks/useExposedReactFormGeneratorProviderValue.hook';
import { ConfigurationBuilderProvider } from '@ingenico/react-configuration-generator';
import type { ReactConfigurationGeneratorApi } from '@ingenico/react-configuration-generator';
import { FormGeneratorProvider } from '@ingenico/react-form-generator';
import { ConfigurationFormBuilderWrapperV2 } from '../configuration-form-builder-wrapper-v2/ConfigurationFormBuilderWrapperV2.ctrl';
import type { FormBuilderHandle } from '@ingenico/react-form-builder';

export function DeviceManagementConfigurationProvider({
  inputs,
  initialCategory,
  customComponents,
  ref,
}: ConfigurationFormBuilderWrapperProps & {
  readonly ref: ForwardedRef<ReactConfigurationGeneratorApi>;
}): ReactElement {
  const value = useExposedConfigurationFormBuilderWrapperProviderValueV2();
  const formGeneratorValue = useExposedReactFormGeneratorProviderValue();
  const formBuilderRef = useRef<FormBuilderHandle>(null);
  return (
    <ConfigurationBuilderProvider value={value}>
      <FormGeneratorProvider value={formGeneratorValue}>
        <ConfigurationFormBuilderWrapperV2
          initialCategory={initialCategory}
          inputs={inputs}
          ref={ref}
          customComponents={customComponents}
          formBuilderRef={formBuilderRef}
        />
      </FormGeneratorProvider>
    </ConfigurationBuilderProvider>
  );
}
